import { createSlice } from "@reduxjs/toolkit";
import { LocalStorageKeys } from "../core";

const initialState = {
  isLoggedIn: localStorage.getItem(LocalStorageKeys.coachToken) ? true : false,
  coach: null,
  coachs: [],
  token: localStorage.getItem(LocalStorageKeys.coachToken),
  isLoading: false,
  profile: null,
  gyms: [],
  gym: {},
};

const coachReducerSlice = createSlice({
  name: "coaches",
  initialState,
  reducers: {
    changeLoadingState: (state, action) => {
      state.isLoading = action.payload;
    },
    setCoach: (state, action) => {
      state.coach = action.payload;
    },
    setCoachState: (state, action) => {
      if (state.coachs.length <= 0 || action.payload.refresh) {
        state.coachs = action.payload.coachs || state.coachs;
      }
      state.isLoading = false;
    },
    addCoachState: (state, action) => {
      state.coachs.unshift(action.payload);
      state.isLoading = false;
    },
    deleteCoachState: (state, action) => {
      state.coachs = state.coachs.filter(
        (coach) => coach._id !== action.payload
      );
      state.isLoading = false;
    },
    setCoachLogin: (state, action) => {
      state.isLoggedIn = true;
      state.isLoading = false;
      localStorage.setItem(LocalStorageKeys.coachToken, action.payload);
    },
    setCoachLogout: (state) => {
      localStorage.removeItem(LocalStorageKeys.coachToken);
      state = {
        isLoggedIn: false,
        admin: null,
        token: null,
      };
    },
    setCoachProfile: (state, action) => {
      state.profile = action.payload;
      state.isLoading = false;
    },
    setGymState: (state, action) => {
      if (state.gyms.length <= 0 || action.payload.refresh) {
        state.gyms = action.payload.gyms || state.gyms;
      }
      state.isLoading = false;
    },
  },
});

export const {
  setCoach,
  setCoachLogin,
  setCoachLogout,
  changeLoadingState,
  setCoachProfile,
  setCoachState,
  addCoachState,
  setGymState,
  deleteCoachState,
} = coachReducerSlice.actions;

export default coachReducerSlice.reducer;
